export const AUTH_REQUEST = "AUTH_REQUEST"
export const AUTH_SUCCESS = "AUTH_SUCCESS"
export const AUTH_LOGOUT = "AUTH_LOGOUT"
export const CHECK_AUTH = "CHECK_AUTH"
export const TOKEN_REQUEST = "TOKEN_REQUEST"
